class PrescriptionRenewalMedicationHistoryFilterSettingModel {
    public dateFrom: Date = null;
    public dateTo: Date = null;
    public selectedStatus: string[] = [];
    public selectedOrigin: string[] = [];
    public isSelectedDetailsCheck: boolean = true;

    constructor(fields?: Partial<PrescriptionRenewalMedicationHistoryFilterSettingModel>) {
        Object.assign(this, fields);
    }
}

export { PrescriptionRenewalMedicationHistoryFilterSettingModel };
